import React, { useCallback, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { enhance } from './enhance';
import ListItem from '../ListItem';
import { useLazyLoad } from '../../../../hocs/useLazyLoad';

const FullList = ({
  items,
  isMobile,
  onListItemMenuClick,
  communityId,
  shouldLoadMoreMembers,
  shouldLoadMoreModerators,
  fetchMoreMembers,
  fetchMoreModerators,
  isListTypeMembers,
  loggedUserId,
  listType,
  showMenu,
}) => {
  const rootRef = useRef();
  const [, setLoaded] = useState(false);
  
  useEffect(() => {setLoaded(true)}, []);

  const handleLoadMore = () => {
    if (isListTypeMembers) {
      fetchMoreMembers(communityId);
      return;
    }

    fetchMoreModerators(communityId);
  };

  const loadMore = useCallback(() => {
    const shouldLoadMore = isListTypeMembers
      ? shouldLoadMoreMembers
      : shouldLoadMoreModerators;
    if (shouldLoadMore) {
      handleLoadMore();
    }
  }, [shouldLoadMoreMembers, shouldLoadMoreModerators]);

  useLazyLoad({
    node: rootRef,
    path: ['parentNode'],
    loadMore,
  });

  return (
    <div
      ref={rootRef}
      className="full-list-modal"
      styleName={classNames('full-list', {
        'full-list-mobile': isMobile,
      })}
    >
      <ul>
        {items.map(item => (
          <li key={item.id} styleName="full-list__item">
            <ListItem
              type={listType}
              item={item}
              avatarSize={32}
              showMenu={showMenu}
              onClick={onListItemMenuClick}
              loggedUserId={loggedUserId}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

FullList.propTypes = {
  showMenu: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isMobile: PropTypes.bool.isRequired,
  onListItemMenuClick: PropTypes.func.isRequired,
  communityId: PropTypes.number.isRequired,
  shouldLoadMoreMembers: PropTypes.bool.isRequired,
  shouldLoadMoreModerators: PropTypes.bool.isRequired,
  fetchMoreMembers: PropTypes.func.isRequired,
  fetchMoreModerators: PropTypes.func.isRequired,
  isListTypeMembers: PropTypes.bool.isRequired,
  loggedUserId: PropTypes.number.isRequired,
  listType: PropTypes.string.isRequired,
};

export default enhance(FullList);



// WEBPACK FOOTER //
// ./src/components/Community/About/FullList/index.jsx